import PropTypes from "prop-types"
import { Flex } from "antd"
import { Text } from "ui/Typography"
import { colors, spacings } from "themes/variables"
import { useTranslation } from "react-i18next"
import { numberToCurrency } from "helpers/string"
import { PAYMENTS } from "../constants"

const CardBreakDown = ({ stripeIncomes }) => {
  if (Array.isArray(stripeIncomes) && stripeIncomes.length > 0) {
    return (
      <>
        {stripeIncomes.map((card, idx) => {
          const { id, type, method, last4, amount } = card || {}
          return (
            <Flex gap={spacings.XS} key={id}>
              <Text>
                {type || ""} {idx + 1} ({method || ""} **** {last4 || ""})
              </Text>
              <Text fw={500}>{numberToCurrency(amount)}</Text>
            </Flex>
          )
        })}
      </>
    )
  }
  return null
}

const PaypalBreakDown = ({ paypalIncomes }) => {
  if (Array.isArray(paypalIncomes) && paypalIncomes.length > 0) {
    return (
      <>
        {paypalIncomes.map((paypal, idx) => {
          const { id, type, amount } = paypal || {}
          return (
            <Flex gap={spacings.XS} key={id}>
              <Text>{type || ""}</Text>
              <Text fw={500}>{numberToCurrency(amount)}</Text>
            </Flex>
          )
        })}
      </>
    )
  }
  return null
}

const RefundBreakdownList = ({ stripeIncomes, paypalIncomes, formattedRefundableAmount, paymentType }) => {
  const { t } = useTranslation()
  return (
    <Flex vertical gap={spacings.S} style={{ backgroundColor: colors.surface1 }} className="p-s">
      <Text fw={500}>
        {t("client.payment.totalRefund")} {formattedRefundableAmount}
      </Text>
      {paymentType === PAYMENTS.STRIPE && <CardBreakDown stripeIncomes={stripeIncomes} />}
      {paymentType === PAYMENTS.PAYPAL && <PaypalBreakDown paypalIncomes={paypalIncomes} />}
    </Flex>
  )
}

CardBreakDown.propTypes = {
  stripeIncomes: PropTypes.array
}

PaypalBreakDown.propTypes = {
  paypalIncomes: PropTypes.array
}

RefundBreakdownList.propTypes = {
  stripeIncomes: PropTypes.array,
  paypalIncomes: PropTypes.array,
  formattedRefundableAmount: PropTypes.string,
  paymentType: PropTypes.string
}

export default RefundBreakdownList
